import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _objectSpread from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/createClass";
import { getPlatform, getReportType } from '../util';
import { isEqual } from 'lodash-es';
import { cookie, Boss } from '@tencent/vft-common';
import { getUrlParam } from '@tencent/vft-common/util';
/**
 * 预置上报参数
 * @type {VftReport.ReportParams}
 */

export var PRESET_PARAMS = {
  /** url链接 */
  f_url: location.pathname,

  /** 域名（H5上报） */
  f_dm: location.host,

  /** 域名协议 */
  f_protocol: location.protocol,

  /** url参数，如果含有$，需要用|||替换，再上报 */
  f_url_param: (decodeURIComponent(location.href).split('?')[1] || '').replace(/\$/g, '|||'),

  /** ptag，优先取url中ptag参数，如果没有则取aid的13级； */
  f_pagetag: getUrlParam('ptag', location.href) || (sessionStorage ? sessionStorage.getItem('ptag') : null) || cookie.get('ptag'),
  f_pt: getPlatform()
};
var DATONG_BOSS_MAP = {
  eid: 'f_hottag',
  btn_title: 'f_resource',
  mod_title: 'f_module',
  mod_id: 'f_hottag'
};

var BossReporter = /*#__PURE__*/function () {
  function BossReporter(options) {
    _classCallCheck(this, BossReporter);

    this.$boss = {
      pv: null,
      event: null
    };
    this.$queue = [];
    var config = options.config,
        extraParams = options.extraParams,
        delay = options.delay,
        observerOptions = options.observerOptions;

    if (!config || !config.event) {
      throw new Error('[reporter] 需要传入对应的Boss配置, 如: { event: { bossId: 1024, pwd: 123 }}');
    }

    var isSameReporter = !config.pv || isEqual(config.pv, config.event);
    this.$boss.event = new Boss(config.event || {});
    this.$boss.pv = isSameReporter ? this.$boss.event : new Boss(config.pv || {});
    this.observer = this._createObserver(observerOptions);
    this.presetParams = PRESET_PARAMS;
    this.extraParams = extraParams;
    this.delay = delay;

    if (!delay) {
      // 页面曝光
      this.report({
        f_type: 0
      });
    }
  }

  _createClass(BossReporter, [{
    key: "ready",
    value: function ready() {
      // 页面曝光
      this.report({
        f_type: 0
      });
      this.delay = false;

      while (this.$queue.length) {
        var _this$$queue$pop = this.$queue.pop(),
            _this$$queue$pop2 = _slicedToArray(_this$$queue$pop, 2),
            params = _this$$queue$pop2[0],
            type = _this$$queue$pop2[1];

        this.report(params, type);
      }
    }
  }, {
    key: "report",
    value: function report(params) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'expose';

      if (!params) {
        throw new Error('[Boss Report] report params is undefined');
      }

      if (this.delay) {
        this.$queue.push([params, type]);
        return;
      }

      var reportData = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, PRESET_PARAMS), this.extraParams()), this._parseParms(params)), {}, {
        f_event: type,
        _dc: Math.random()
      });

      this.$boss.event.report(reportData);

      if (this.$boss.pv && type === 'expose') {
        this.$boss.pv.report(reportData);
      }
    }
  }, {
    key: "setExtraParams",
    value: function setExtraParams() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.presetParams = _objectSpread(_objectSpread({}, this.presetParams), params);
    }
  }, {
    key: "useDirective",
    value: function useDirective(el, binding, vnode) {
      var _this = this;

      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      var _a;

      var event = options.event;

      if (event === 'unbind') {
        if (el.report.click) {
          el.removeEventListener('click', el.report.click, true); // eslint-disable-next-line

          el.report.click = null;
        }

        if (el.observed) {
          this.observer.unobserve(el);
        }
      } else {
        if (!binding.value) {
          if (el.observed) {
            // eslint-disable-next-line
            el.observed = false;
            this.observer.unobserve(el);
          }

          if ((_a = el.report) === null || _a === void 0 ? void 0 : _a.click) {
            el.removeEventListener('click', el.report.click, true); // eslint-disable-next-line

            el.report.click = null;
          }

          console.warn("[v-report:".concat(event, "] \u4E0A\u62A5\u53C2\u6570\u4E3A\u7A7A"), el);
          return;
        }

        var type = getReportType(binding.modifiers);
        var params = binding.value;

        if (type !== 'module' && binding.arg) {
          params.f_module = binding.arg;
        }

        if (el.report && isEqual(el.report.params, params)) {
          return;
        }

        if (!el.report) {
          // eslint-disable-next-line
          el.report = {
            type: type,
            params: params
          };
        }

        if (type === 'module') {
          // eslint-disable-next-line
          el.report.params.f_type = 1;
        } else {
          // eslint-disable-next-line
          el.report.params = Object.assign({}, el.report.params, params);
        }

        if (binding.modifiers.once) {
          return;
        } // 注册 Dom 曝光上报


        if (['module', 'all', 'expose'].includes(type)) {
          if (el.observed) {
            this.observer.unobserve(el);
          } // eslint-disable-next-line


          el.observed = true;
          this.observer.observe(el);
        } // 首次注册时，未绑定点击事件


        if (['all', 'click'].includes(type) && !el.report.click) {
          // eslint-disable-next-line
          el.report.click = function () {
            _this.report(el.report.params, 'click');
          };

          el.addEventListener('click', el.report.click, true);
        }
      }
    }
  }, {
    key: "_parseParms",
    value: function _parseParms() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var result = {};
      Object.keys(params).forEach(function (key) {
        if (DATONG_BOSS_MAP[key]) {
          result[DATONG_BOSS_MAP[key]] = params[key];
        } else {
          result[key] = params[key];
        }
      });
      return result;
    }
  }, {
    key: "_createObserver",
    value: function _createObserver(observerOptions) {
      var _this2 = this;

      return new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var target = entry.target,
              isIntersecting = entry.isIntersecting;

          if (isIntersecting) {
            // eslint-disable-next-line
            _this2.report(target.report.params, 'expose');
          }
        });
      }, _objectSpread({
        root: document.body,
        threshold: 0.1
      }, observerOptions));
    }
  }]);

  return BossReporter;
}();

export { BossReporter as default };